var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_938_1345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7674 0.767389C10.7911 -0.208922 9.20816 -0.208921 8.23185 0.76739L0.767389 8.23185C-0.208922 9.20817 -0.208921 10.7911 0.76739 11.7674L8.23185 19.2319C9.20817 20.2082 10.7911 20.2082 11.7674 19.2319L19.2319 11.7674C20.2082 10.7911 20.2082 9.20816 19.2319 8.23185L11.7674 0.767389ZM8.99956 5.99962C8.99956 5.44734 9.44728 4.99962 9.99956 4.99962C10.5518 4.99962 10.9996 5.44734 10.9996 5.99962V9.99962C10.9996 10.5519 10.5518 10.9996 9.99956 10.9996C9.44728 10.9996 8.99956 10.5519 8.99956 9.99962V5.99962ZM10.9996 13.9996C10.9996 14.5519 10.5518 14.9996 9.99956 14.9996C9.44728 14.9996 8.99956 14.5519 8.99956 13.9996C8.99956 13.4473 9.44728 12.9996 9.99956 12.9996C10.5518 12.9996 10.9996 13.4473 10.9996 13.9996Z",
    fill: "#D72C0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_938_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.f3beb224619af48332d2fa0649a444ba.svg";
export { ForwardRef as ReactComponent };